<mat-form-field class="w-full {{ labelStyle }}" appearance="outline">
  <mat-label>{{ labelTitle }}</mat-label>
  <textarea
    [placeholder]="placeholder"
    [formControl]="control"
    matInput></textarea>
  @if (control.touched) {
  <mat-error>
    <small customLabel [errors]="control.errors"></small>
  </mat-error>
  }
</mat-form-field>
